import {solicitation} from '@/api-services'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useSolicitationStore = defineStore('solicitationStore', {
  state: () => ({
    allSolicitation: [],
    solicitationDetail: {},
    isCreateSuccess: false,
    isUpdateSuccess: false,
    loading: false,
    error: null,
  }),

  actions: {
    async getAllSolicitation(query) {
      this.loading = true
      try {
        const response = await solicitation.get(query)
        const data = response.data
        this.allSolicitation = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getSolicitationById(id) {
      this.loading = true
      try {
        const response = await solicitation.getById(id)
        const data = response.data
        this.solicitationDetail = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async addSolicitation(payload) {
      this.loading = true
      try {
        const response = await solicitation.create(payload)
        const data = response.data
        this.solicitationDetail = data
        this.isCreateSuccess = true
        toast.success(`Thank you. We have received your inquiry and our
        team will contact you shortly to process your request.`)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async updateSolicitation(id, payload) {
      this.loading = true
      try {
        const response = await solicitation.update(id, payload)
        const data = response.data
        this.solicitationDetail = data
        this.isUpdateSuccess = true
        toast.success(successHandler('UPDATE_SOLICITATION_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async deleteSolicitation(id) {
      this.loading = true
      try {
        await solicitation.delete(id)
        toast.success(successHandler('DELETE_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },
  },
})
